import React from 'react';

import {
  Container,
  WysiwygField,
} from '@uncinc/uncinc-react-kitchen-sink';
import truncate from 'truncate-markup-string';

import {
  CoreLink,
} from '@uncinc/react-drupal-core';

import { DEFAULT_LANGUAGE } from '../../config/constants';
import './style.scss';

const SearchTeaser = ({ entity }) => {
  const title = entity.getIn(['title', 0, 'value']);
  const body = entity.getIn(['body', 0, 'processed'], '');
  const url = entity.getIn(['paths', DEFAULT_LANGUAGE]);
  const contentType = entity.getIn(['type', 0, 'target_id'], '');

  const charLimit = 200;
  const openTag = '<span>';
  const closeTag = '</span>';
  const prettyEllipsis = true;

  return (
    <div className="SearchTeaser">
      <Container>
        <div className="SearchTeaser__hero row">
          <div className="col-12 col-md-10 col-lg-8">

            <div className="SearchTeaser__tag">
              <label htmlFor={contentType}>{contentType}</label>
            </div>

            <h4>{title}</h4>

            <div className="SearchTeaser__url">
              <CoreLink to={url}>https://www.verpact.nl{url}</CoreLink>
            </div>

            <WysiwygField
              className="SearchTeaser__body"
              property="schema:text"
              html={truncate(body, charLimit, openTag, closeTag, prettyEllipsis)}
            />
          </div>
        </div>
      </Container>
    </div>
  );
};

export default SearchTeaser;
